// Deep-link-режимы редактора (?tool=X). Значения совпадают с валидными `tab`
// панелей внутри PdfEditor (sign/form). Единый источник для логики, работающей
// со значением tool: гард deep-link-эффекта (PdfEditor) и аналитика
// (TOOL_EVENT_ACTIONS). Карточки и меню держат эти значения в href-строках
// напрямую — это внешний URL-контракт, менять их через импорт не требуется.
export const EDITOR_TOOLS = {
  SIGN: 'sign',
  FORM: 'form',
};

export const EDITOR_TOOL_VALUES = Object.values(EDITOR_TOOLS);
